import * as React from 'react';
import { useTheme, useColorScheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useLanguage } from '../../contexts/LanguageContext';

export default function ThemeSwitcher() {
  const theme = useTheme();
  const { t, direction } = useLanguage();

  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const preferredMode = prefersDarkMode ? 'dark' : 'light';

  const { mode, setMode } = useColorScheme();
  const isRtl = direction === 'rtl';
  const paletteMode = !mode || mode === 'system' ? preferredMode : mode;

  const toggleMode = React.useCallback(() => {
    setMode(paletteMode === 'dark' ? 'light' : 'dark');
  }, [setMode, paletteMode]);

  return (
    <Tooltip
      title={paletteMode === 'dark' ? t('theme.lightMode') : t('theme.darkMode')}
      enterDelay={1000}
    >
      <div>
        <IconButton
          size="small"
          aria-label={`${t('theme.switchTo')} ${paletteMode === 'dark' ? t('theme.lightMode') : t('theme.darkMode')}`}
          onClick={toggleMode}
          sx={{
            marginRight:  `${isRtl? 8 : 0 }px`,
          }}
        >
          {theme.getColorSchemeSelector ? (
            <React.Fragment>
              <LightModeIcon
                sx={{
                  display: 'inline',
                  [theme.getColorSchemeSelector('dark')]: {
                    display: 'none',
                  },
                }}
              />
              <DarkModeIcon
                sx={{
                  display: 'none',
                  [theme.getColorSchemeSelector('dark')]: {
                    display: 'inline',
                  },
                }}
              />
            </React.Fragment>
          ) : null}
        </IconButton>
      </div>
    </Tooltip>
  );
}
